import React, { useId } from "react";
import {Button, Typography} from "@mui/material"
import Popover from '@mui/material/Popover';
import PopupState, {bindPopover, bindTrigger} from 'material-ui-popup-state';

interface PopupConfirmProps {
    text: string,
    disabled?: boolean,
    yesText?: string,
    noText?: string,
    onYes?: () => void,
    onNo?: () => void,
    children: React.ReactElement;
}

const PopupConfirm = ({
                          text,
                          disabled = false,
                          yesText = 'Yes',
                          noText = 'No',
                          onYes,
                          onNo,
                          children
                      }: PopupConfirmProps) => {
    const popupId = useId();
    return (
            <PopupState variant="popover"
                        popupId={popupId}>
                {(popupState) => (
                        <div>
                            {React.cloneElement(children, {
                                ...bindTrigger(popupState)
                            })}
                            <Popover
                                    {...bindPopover(popupState)}
                                    anchorOrigin={{
                                        vertical: 'bottom',
                                        horizontal: 'center',
                                    }}
                                    transformOrigin={{
                                        vertical: 'top',
                                        horizontal: 'center',
                                    }}
                                    onKeyDown={e => {
                                        if (e.key === "Enter") {
                                            onYes?.();
                                            popupState.close();
                                        } else {
                                            onNo?.();
                                            popupState.close();
                                        }
                                    }}
                            >
                                <Typography sx={{p: 2}}>{text}</Typography>
                                <div
                                        style={{
                                            display: "flex",
                                            justifyContent: "flex-end",
                                            paddingBottom: "5px",
                                            marginRight: "5px"
                                        }}>
                                    <Button
                                            variant="contained"
                                            onClick={() => {
                                                onYes?.();
                                                popupState.close();
                                            }}>
                                        {yesText}
                                    </Button>
                                    <Button
                                            variant="contained"
                                            color={"error"}
                                            onClick={() => {
                                                onNo?.();
                                                popupState.close();
                                            }}
                                            sx={{marginLeft: "5px"}}>
                                        {noText}
                                    </Button>
                                </div>
                            </Popover>
                        </div>
                )}
            </PopupState>
    )
}

export default PopupConfirm;